let current_nonce = wpApiSettings.ajax_nonce;
export const createFetchOptions = (nonce, action, body) => {
    return {
        method: "POST",
        credentials: "same-origin",
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            "Cache-Control": "no-cache",
        },
        body: new URLSearchParams(Object.assign({ action, nonce }, body)),
    };
};
export function isWpSuccess(result) {
    return result.data !== undefined;
}
export async function wpFetch(action, data) {
    const nonce = wpApiSettings.ajax_nonce;
    const url = wpApiSettings.ajax_url;
    const options = createFetchOptions(nonce, action, data);
    const res = await fetch(url, options);
    const result = await res.json();
    if (!result.success) {
        return { message: result.message };
    }
    return { data: result.data };
}
export async function wpFetchRestApi(endpoint, method, data) {
    const url = wpApiSettings.root + 'nemonetti/v1/' + endpoint;
    const nonce = current_nonce || wpApiSettings.nonce;
    const body = data !== undefined ? JSON.stringify(data) : undefined;
    const response = await fetch(url, {
        headers: {
            'Content-Type': 'application/json',
            'X-WP-Nonce': nonce,
        },
        method: method,
        body: body,
        credentials: 'include',
    });
    const json = await response.json();
    if (response.ok) {
        return { data: json };
    }
    else {
        return {
            errorData: json,
            message: json.message,
        };
    }
}
export function assertEventType(event, eventType) {
    if (event.type !== eventType) {
        throw new Error(`Invalid event: expected "${eventType}", got "${event.type}"`);
    }
}
export const logCtxAndEv = (id) => (ctx, ev) => {
    console.dir({ logCtxAndEv: { id, ctx, ev } });
    return ctx;
};
